<template>
<div class="chapter">
<div class="inner_page">
<div class="title" id="tp01"><a id="pageiv">
<h2 class="titlePageTitle">Mysterious Skin</h2>
<p class="titlePageText">A Novel</p>
<h2 class="titlePageAuthor">Scott Heim</h2>
<p class="titlePageLogo"><img alt="" src="logo.jpg"/></p>
</a></div><a id="pageiv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780061737190_title.vue?599bca56